module.exports = __webpack_public_path__ + "img/send-map.13d209e7.svg";